import { ModalBody, ModalHeader } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import useFormatById from "src/hooks/utils/useFormatById";
import React from "react";
import { ReactComponent as GreenCheckIcon } from "src/assets/static/icons/green-check-icon.svg";
import { ReactComponent as XCircleIcon } from "src/assets/static/icons/x-circle.svg";
import styles from "src/assets/styles/requestCall/successModal.module.scss";

function SuccessModal({ onClose }) {
  const f = useFormatById();

  return (
    <Modal
      className="corp-modal call-modal-uno"
      show
      centered
      size="lg"
      scrollable
    >
      <ModalHeader className={styles.header} style={{ background: "white" }}>
        <button
          type="button"
          className={styles.closeButton}
          // onClick={() => setIsSuccessModalOpen(false)}
          onClick={() => onClose()}
        >
          <XCircleIcon />
        </button>
      </ModalHeader>
      <ModalBody className={styles.container}>
        <GreenCheckIcon />
        <h3 className={styles.title}>{f("requestCall.successMessage")}</h3>
      </ModalBody>
    </Modal>
  );
}

export default SuccessModal;
